/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { LuChevronRight, LuPlus } from 'react-icons/lu';
import { Link, useLocation } from 'react-router-dom';
import Slider from "react-slick";
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { showToast } from '../../showTost';
import Payment from '../../Payment/Payment';
import BookingDetails from './BookingDetails';
import AddPatient from './AddPatient';
import { IoCheckmark } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import Wallet from "../../assets/Icon/wallet.svg";
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
const Bookappoinment = () => {

  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl, isPayment, setIsPayment, paymentStatus, patientStatus, setPaymentStatus, transactionid } = useContext(MyContext);
  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  const [loading, setLoading] = useState(true);
  const [isDriverSelected, setIsDriverSelected] = useState(false);
  const [relationshipData, setRelationshipData] = useState([]);
  const [booldData, setBooldData] = useState([]);
  const [isPatient, setIsPatient] = useState(false);
  const [selectPatient, setSelectPatient] = useState([0]);
  const [couponList, setCouponList] = useState([]);
  const [isCouponShow, setIsCouponShow] = useState(false);
  const [docProfileData, setDocProfileData] = useState();
  const [departmentData, setDepartmentData] = useState();
  const [hospitalName, setHospitalName] = useState();
  const [familyData, setFamilyData] = useState([]);
  const [couponCode, setCouponCode] = useState();
  const [totalAmt, setTotalAmt] = useState();
  const [totalAmt2, setTotalAmt2] = useState();
  const [commissionData, setCommissionData] = useState();
  const [tax, setTax] = useState();
  const [taxType, setTaxType] = useState();
  const [charges, setCharges] = useState();
  const [serviceTotal, setServiceTotal] = useState();
  const [extraPatientCharges, setExtraPatientCharges] = useState();
  const [additionalNote, setAdditionalNote] = useState();
  const [bookingData, setBookingData] = useState();
  const [isBooking, setIsBooking] = useState(false);
  const [myWallet, setMyWallet] = useState();
  const [myWallet2, setMyWallet2] = useState();
  const [wallet, setWallet] = useState();
  const [allData, setAllData] = useState();

  const Location = useLocation();
  const Daata = Location.state?.data;

  const abc = new Date(Daata?.Date);
  const dateStr = abc.toDateString();
  const split = dateStr.split(" ");

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      { breakpoint: 770, settings: { slidesToShow: 6, slidesToScroll: 1 } },
      { breakpoint: 580, settings: { slidesToShow: 5, slidesToScroll: 1 } },
      { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 330, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    ],
  };

  const toggleDriverSelection = () => setIsDriverSelected(prev => !prev);


  useEffect(() => {

    window.scrollTo(0, 0);

    HandleFetchData();
    axios.get(`${ApiBaseUrl}/customer/family_member_add_detail`)
      .then((res) => {
        const { relationship_list, blood_group_list } = res.data;
        setRelationshipData(relationship_list);
        setBooldData(blood_group_list);
      })
      .catch((error) => {
        console.error(error);
      });

    setServiceTotal(Daata.showtypeprice);
    const totalcharg = (Daata.showtypeprice * Daata.commission) / 100;
    setCharges(totalcharg.toFixed(2));

  }, []);

  useEffect(() => {
    if (!commissionData) return;

    if (commissionData.commisiion_type === "fix") {
      setTax(commissionData.commission_rate);
      setTaxType(commissionData.commisiion_type);
    } else {
      const totalTax = Daata.showtypeprice * (commissionData.commission_rate / 100);
      setTax(totalTax.toFixed(2));
      setTaxType(commissionData.commission_rate + commissionData.commisiion_type);
    }

  }, [commissionData]);

  useEffect(() => {
    const Total = Number(serviceTotal) + Number(charges) + Number(tax);
    setTotalAmt(Total);
    setTotalAmt2(Total);
  }, [serviceTotal, charges, tax]);

  useEffect(() => {
    const finalTotal = couponCode ? totalAmt - couponCode.amt : totalAmt2;
    setTotalAmt(finalTotal);
  }, [couponCode]);


  useEffect(() => {
    let adjustedTotal = totalAmt2;

    if (couponCode) {
      adjustedTotal -= couponCode.amt;
    }

    const isWalletSufficient = myWallet > totalAmt;

    if (isWalletSufficient) {
      if (isDriverSelected) {
        setTotalAmt(0);
        setWallet(adjustedTotal);
        setMyWallet2((myWallet - totalAmt).toFixed(2));
      } else {
        setTotalAmt(adjustedTotal);
        setWallet(0);
        setMyWallet2(myWallet);
      }
    } else {
      if (isDriverSelected) {
        setTotalAmt(totalAmt - myWallet);
        setWallet(myWallet);
        setMyWallet2(0);
      } else {
        setTotalAmt(adjustedTotal);
        setWallet(0);
        setMyWallet2(myWallet);
      }
    }
  }, [isDriverSelected]);



  const SelectPatientHandle = (index) => {

    if (isDriverSelected) {
      setIsDriverSelected(!isDriverSelected);
    }

    if (selectPatient.includes(index)) {
      setSelectPatient(selectPatient.filter((id) => id !== index));
      setTotalAmt(totalAmt - extraPatientCharges);
      setTotalAmt2(totalAmt2 - extraPatientCharges);

    } else {
      setSelectPatient([...selectPatient, index]);
      setTotalAmt(totalAmt + extraPatientCharges);
      setTotalAmt2(totalAmt2 + extraPatientCharges);
    }
  };

  useEffect(() => {
    HandleFetchData();
    setIsPatient(false);
  }, [patientStatus]);

  const HandleFetchData = () => {
    const UserId = secureLocalStorage.getItem("Userid");
    if (UserId) {
      const Data = {
        id: UserId,
        d_id: Daata?.Docid,
        sub_depar_id: Daata?.subdeparid,
        hospital_id: Daata?.HospitalId
      };
      axios.post(`${ApiBaseUrl}/customer/cart_data`, Data)
        .then((res) => {
          // console.log(res);
          const { ResponseCode, coupon, doctor, dep_sub_ser_list, hospital, family_member, commission_data, extra_doctor_charge, wallet_amount } = res.data;
          if (ResponseCode === 200) {
            setLoading(false);
            setMyWallet(wallet_amount.toFixed(2));
            setCouponList(coupon);
            setDocProfileData(doctor);
            setDepartmentData(dep_sub_ser_list);
            setHospitalName(hospital);
            setFamilyData(family_member);
            const selectedId = family_member?.[0]?.id;
            setSelectPatient(selectedId ? [selectedId] : "");
            setCommissionData(commission_data);
            setExtraPatientCharges(extra_doctor_charge);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleCoupanAdd = (code, amt, id) => {
    setCouponCode({ code, amt, id });
    showToast({ title: t("Coupon Add Successful"), id: "success" });
    setIsCouponShow(false);
  };

  const HandleCoupanRemove = () => {
    if (couponCode) {
      setCouponCode("");
    } else {
      setIsCouponShow(true);
    }
    if (isDriverSelected) {
      setIsDriverSelected(!isDriverSelected);
    }
  };


  const HandleProceed = () => {

    if (selectPatient.length <= 0) {
      showToast({ title: t("Please Select Patient"), id: "error" });
      return;
    }

    if (isDriverSelected && totalAmt === 0) {
      HandleBookAppointment();
    } else {
      setIsPayment(true);

      const Userid = secureLocalStorage.getItem("Userid");

      if (Userid) {

        const additionalPrice = selectPatient.length >= 2 && (selectPatient.length - 1) * extraPatientCharges;
        const TotalPrice = couponCode ? totalAmt2 - couponCode.amt : totalAmt2;

        const Data = {
          id: Userid,
          d_id: Daata.Docid,
          sub_depar_id: Daata.subdeparid,
          hospital_id: Daata.HospitalId,
          department_id: Daata.DepartmentId,
          date: Daata.Date,
          date_type: Daata.datetype,
          time: Daata.time,
          family_mem_id: selectPatient,
          show_type: Daata.show_type,
          show_type_price: Daata.showtypeprice,
          tot_price: TotalPrice,
          additional_price: additionalPrice ? additionalPrice : "0",
          coupon_id: couponCode ? couponCode.id : "0",
          coupon_amount: couponCode ? couponCode.amt : "0",
          doctor_commission: Daata.commission,
          site_commisiion: tax,
          wallet_amount: isDriverSelected ? (totalAmt2 - totalAmt) : "0",
          additional_note: additionalNote ? additionalNote : ""
        };

        setAllData(Data);

        sessionStorage.setItem("page", "1");
      }
    }
  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentDone") {
      HandleBookAppointment();
      setIsPayment(false);
      setPaymentStatus("");
    } else {
      setIsPayment(false);
      setPaymentStatus("");
    }
  }, [paymentStatus]);

  const HandleBookAppointment = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    const PaymentId = sessionStorage.getItem("Paymentid");

    if (Userid) {

      const additionalPrice = selectPatient.length >= 2 && (selectPatient.length - 1) * extraPatientCharges;
      const TotalPrice = couponCode ? totalAmt2 - couponCode.amt : totalAmt2;

      const Data = {
        id: Userid,
        d_id: Daata.Docid,
        sub_depar_id: Daata.subdeparid,
        hospital_id: Daata.HospitalId,
        department_id: Daata.DepartmentId,
        date: Daata.Date,
        date_type: Daata.datetype,
        time: Daata.time,
        family_mem_id: selectPatient,
        show_type: Daata.show_type,
        show_type_price: Daata.showtypeprice,
        tot_price: TotalPrice,
        additional_price: additionalPrice ? additionalPrice : "0",
        coupon_id: couponCode ? couponCode.id : "",
        coupon_amount: couponCode ? couponCode.amt : "0",
        doctor_commission: charges,
        site_commisiion: tax,
        payment_id: PaymentId ? PaymentId : "",
        wallet_amount: isDriverSelected ? wallet : "0",
        additional_note: additionalNote ? additionalNote : "",
        transactionId: transactionid || "",
      };

      axios.post(`${ApiBaseUrl}/customer/book_appointment`, Data)
        .then((res) => {
          const { message, ResponseCode, appointment_id } = res.data;
          // console.log(res);
          if (ResponseCode === 200) {
            // console.log("book_appointment", res);
            HandleBookAppointGet(appointment_id);
            setIsPayment(false);
            showToast({ title: message, id: "success" });
            setIsBooking(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const status = sessionStorage.getItem("Bookid");
    if (status) {
      HandleBookAppointGet(status);
    }
  }, []);

  const HandleBookAppointGet = (id) => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/success_appo_detail`, { id: Userid, appointment_id: id })
        .then((res) => {
          // console.log("success_appo_detail", res);
          setBookingData(res.data);
          sessionStorage.removeItem("Bookid");
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    loading
      ? document.body.style.overflow = "hidden"
      : document.body.style.overflow = "auto";
  }, [loading]);

  return (
    <div className='pb-[50px]'>
      {loading
        ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
        : <div className='width-container pb-[50px]'>
          <div className="pt-[25px] book-appointment">
            <div className="flex items-center justify-between top-section gap-[10px]">
              <Link to="/"
                className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black overflow-hidden">
                <IoIosArrowBack className=' group-hover:text-white' />
                <h1 className='font-[500] group-hover:text-white whitespace-nowrap overflow-hidden overflow-ellipsis'>{t("Go Home")}</h1>
              </Link>
              <div className="flex items-center gap-[10px] overflow-hidden">
                <Link to="/doctor-profile" className='font-[500] text-gray-700 whitespace-nowrap overflow-hidden overflow-ellipsis'>{t("Doctor Profile")}</Link>
                <IoIosArrowForward />
                <h1 className='font-[500] text-gray-400 whitespace-nowrap overflow-hidden overflow-ellipsis'>{t("Book Appointment")}</h1>
              </div>
            </div>

            <div className="book-section">
              <div className="width-box">

                <div className="section-1">
                  <div className="box">
                    <img src={ImgBaseUrl + docProfileData?.logo} alt="" />
                    <div className="details">
                      <h1>{docProfileData?.name}</h1>
                      <p>{departmentData?.department_name}</p>
                      <div className="flex items-center gap-[5px]">
                        <span className='flex items-center gap-[5px] font-[500] text-gray-500'><FaStar className='text-orange-400' />{docProfileData?.avg_star}.0</span>
                        <div className='flex items-center gap-[5px]'>
                          <span className='w-[5px] h-[5px] bg-gray-500 block rounded-[50px] mt-[1px]'></span>
                          <h3 className='font-[500] text-gray-500 '>{docProfileData?.year_of_experience} {t("Years Experience")}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section-2">
                  <h1 className='mb-[5px] title'>{t("Appointment Details")}</h1>
                  <div className="flex items-center justify-between border-[1px] border-[#8080803b] rounded-[10px] py-[5px] px-[10px]">
                    <div className="details">
                      <div className='w-[70px] h-[70px] rounded-[10px] overflow-hidden bg-gray-200'>
                        <img className='w-[100%] h-[100%] object-cover' src={ImgBaseUrl + hospitalName?.image} alt="" />
                      </div>
                      <div className="">
                        <h1 className='title'>{t(Daata?.showtitle)}</h1>
                        <p>{hospitalName?.name}</p>
                        <div className="flex items-center gap-[5px]">
                          <span className='flex items-center gap-[5px] font-[500] text-[gray] text-[14px]'>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#808080" stroke-width="1.5"></path><path d="M3 9H21" stroke="#808080" stroke-width="1.5" stroke-linecap="round"></path><path d="M8 2L8 5" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16 2V5" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="12" cy="15" r="1" fill="#808080"></circle><circle cx="16" cy="15" r="1" fill="#808080"></circle><circle cx="8" cy="15" r="1" fill="#808080"></circle></svg>
                            {split[2]}, {split[1]} {split[3]}
                          </span>
                          <div className='flex items-center gap-[5px]'>
                            <span className='w-[5px] h-[5px] bg-gray-500 block rounded-[50px] mt-[1px]'></span>
                            <h3 className='font-[500] text-[gray] text-[14px]'>{Daata?.time}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h1 className='title'>{Daata?.showtypeprice}.0{currency}</h1>
                  </div>
                </div>

                <div className="section-3">
                  <h1 className='title'>{t("Select Patient")}</h1>
                  <div className="slider-container mt-[20px]">
                    <Slider {...settings}>
                      <div onClick={() => setIsPatient(true)} className="add-box"><LuPlus /></div>
                      {familyData?.map((item, index) => {
                        const isSelected = selectPatient.includes(item.id);
                        return (
                          <div key={index} className="">
                            <div
                              onClick={() => SelectPatientHandle(item.id)}
                              className="patient-box text-center cursor-pointer relative overflow-visible"
                            >
                              <img
                                className={`patient-img ${isSelected ? "border-[3px] border-[#0d4047]" : ""}`}
                                src={`${ImgBaseUrl}${item.profile_image}`}
                                alt="patient"
                              />
                              {isSelected && (
                                <div className="absolute right-[5px] bottom-[28px] p-[2px] rounded-[50px] bg-white">
                                  <div className="bg-[#0d4047] rounded-[50px] p-[2px]">
                                    <IoCheckmark className="text-white" />
                                  </div>
                                </div>
                              )}

                              <h1 className="font-[500] text-[18px]">{item.name}</h1>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </div>

              </div>

              <div className="width-box">

                <div className="section-4">
                  <h1 className='title'>{t("Message")}</h1>
                  <textarea onChange={(e) => setAdditionalNote(e.target.value)} className='textarea focus-within:border-[#0d4047] border-[2px] border-[#8080803b]' placeholder={t('Message')}></textarea>
                </div>

                {myWallet !== "0" && <div className="section-5">
                  <div className="flex items-center justify-between mb-[10px]">
                    <h1 className='title'>{t("Pay from Wallet")}</h1>
                    <label className="switch2">
                      <input type="checkbox" checked={isDriverSelected} onChange={toggleDriverSelection} />
                      <span className="slider round"></span>
                    </label>
                  </div>
                  <div className="border-[1px] border-[#8080803b] py-[10px] px-[5px] rounded-[10px] flex items-center justify-between">
                    <div className="flex items-center gap-[5px]">
                      <img src={Wallet} alt="" />
                      <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                    </div>
                    <h1 className='title text-[#0d4047]'>{currency}{isDriverSelected ? myWallet2 : myWallet}</h1>
                  </div>
                </div>}

                {couponList.length >= 1 && <div className="section-6">
                  <div className="flex items-center justify-between border-b-[1px] pb-[10px] border-[#8080803b]">
                    <div className="flex items-center gap-[5px]">
                      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="#0d4047" stroke="none" ><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
                      <div className="">
                        <h1 className='title text-[#0d4047]'>{t("Apply Coupon")}</h1>
                        {couponCode && <span className='text-[16px]'>{t("Use Code")} : <span className='font-[500]'>{couponCode.code}</span></span>}
                      </div>
                    </div>
                    <button onClick={HandleCoupanRemove} className={`font-[500] ${couponCode ? "text-red-500" : "text-[#0d4047]"} text-[18px]`}>{couponCode ? t("Remove") : t("Apply")}</button>
                  </div>
                  <div onClick={() => !couponCode && setIsCouponShow(true)} className="flex items-center justify-between py-[10px] cursor-pointer">
                    <h1 className=' text-gray-400 text-[16px]'>{t("View All Coupons")}</h1>
                    <LuChevronRight className='text-gray-400 text-[20px]' />
                  </div>
                </div>}

                <div className="section-7">
                  <h1 className='title'>{t("Review Your Requirements for This Request")}</h1>
                  <div className="data">
                    <h1 className='text-gray-700 text-[16px]'>{t("Service Total")}</h1>
                    <h1 className='font-[500] text-[16px]'>{serviceTotal}.00{currency}</h1>
                  </div>

                  <div className="data">
                    <h1 className='text-gray-700 text-[16px]'>{t("Additional Service Charge(s)")} ({Daata?.commission}%)</h1>
                    <h1 className='font-[500] text-[16px]'>+{charges}{currency}</h1>
                  </div>

                  {isDriverSelected && <div className="data">
                    <h1 className='text-gray-700 text-[16px]'>{t("Wallet")}</h1>
                    <h1 className='font-[500] text-[16px]'>-{wallet}{currency}</h1>
                  </div>}

                  {couponCode && <div className="data">
                    <h1 className='text-gray-700 text-[16px]'>{t("Coupon")}</h1>
                    <h1 className='font-[500] text-[16px]'>-{couponCode.amt}{currency}</h1>
                  </div>}


                  <div className="data">
                    <h1 className='text-gray-700 text-[16px]'>{t("Service Fee & Tax")} ({taxType})</h1>
                    <h1 className='font-[500] text-[16px]'>+{tax}{currency}</h1>
                  </div>

                  {selectPatient.length >= 2 && <div className="data">
                    <h1 className='text-gray-700 text-[16px]'>{t("Additional Patient Charge")} (${extraPatientCharges})</h1>
                    <h1 className='font-[500] text-[16px]'>+{extraPatientCharges}{currency}</h1>
                  </div>}

                  <div className="flex items-center justify-between mt-[5px]">
                    <h1 className='text-[16px] font-[500]'>{t("Total Payable Amount")}</h1>
                    <h1 className='font-[500] text-[16px]'>{totalAmt.toFixed(2)}{currency}</h1>
                  </div>
                </div>
              </div>

            </div>

            <div className="btn-box">
              <div className="flex items-center justify-between mt-[20px]">
                <div className="">
                  <h1 className='title'>{currency}{totalAmt.toFixed(2)}</h1>
                  <span className='text-[#0d4047]'>{t("View Detailed Bill")}</span>
                </div>
                <button onClick={HandleProceed} className='bg-[#0d4047] text-white font-[500] text-[16px] min-w-[200px] py-[5px] rounded-[5px]'>{t("Proceed")}</button>
              </div>
            </div>
          </div>
        </div>}

      {isPatient && <div onClick={() => setIsPatient(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]'>
        <div onClick={(e) => e.stopPropagation()} className="add-patient">
          <AddPatient Relation={relationshipData} BooldType={booldData} />
        </div>
      </div>}

      {isCouponShow && <div onClick={() => setIsCouponShow(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]'>
        <div onClick={(e) => e.stopPropagation()} className="add-patient max-h-[700px] scroll-container" style={{ borderRadius: "10px" }}>
          <h1 className='font-[500] text-[18px] mb-[5px]'>{t("Best Coupon")}</h1>
          {couponList.map((item, index) => {
            return <div key={index} className="border-[1px] rounded-[10px] p-[10px] border-[#8080803b] mb-[5px] flex items-center justify-between">
              <div className="">
                <div className="leading-[20px]">
                  <h1 className='font-[500] text-[20px]'>{item.title}</h1>
                  <p className='text-gray-500'>{item.sub_title}</p>
                </div>
                <div className="mt-[10px]">
                  <h1>{t("Coupon Code")}: <span className='text-[#0d4047] font-[500]'>{item.code}</span></h1>
                  <h1>{t("Coupon Amount")}: <span className='font-[500]'>{currency}{item.discount_amount}</span></h1>
                  <h1>{t("Minimum Amount")}: <span className='font-[500]'>{currency}{item.min_amount}</span></h1>
                  <h1>{t("Ex Date")}: <span className='font-[500]'>{item.end_date}</span></h1>
                </div>
                <button onClick={() => HandleCoupanAdd(item.code, item.discount_amount, item.id)} disabled={totalAmt < item.min_amount} className={` ${totalAmt > item.min_amount ? "coupon-btnAct" : "coupon-btnDic"}`}>{t("Apply Coupon")}</button>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="#ff8000" stroke="none" ><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
            </div>
          })}
        </div>
      </div>}

      {isPayment && <div onClick={() => setIsPayment(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0px 0px" }} onClick={(e) => e.stopPropagation()} className="bottme-box">
          <h1 className='font-[500] text-[20px]'>{t("Select Payment Method")}</h1>
          <Payment Amount={totalAmt} Data={allData} />
        </div>
      </div>}

      {isBooking && <div className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
        <div className="bottme-box">
          <BookingDetails Data={bookingData} />
        </div>
      </div>}

    </div>
  )
}

export default Bookappoinment
/* jshint ignore:end */